import * as Sentry from '@sentry/core';

var LoggerTag = /*#__PURE__*/function (LoggerTag) {
  LoggerTag["URL"] = "api.url";
  LoggerTag["RESOURCE"] = "api.resource";
  LoggerTag["PATH"] = "api.path";
  LoggerTag["METHOD"] = "api.method";
  LoggerTag["STATUS"] = "response.status";
  LoggerTag["TYPE"] = "response.type";
  return LoggerTag;
}(LoggerTag || {});
var LoggerContext = /*#__PURE__*/function (LoggerContext) {
  LoggerContext["REQUEST"] = "request";
  LoggerContext["RESPONSE"] = "response";
  return LoggerContext;
}(LoggerContext || {});
class ApiClientError extends Error {
  constructor(error) {
    super();
    this.name = 'ApiClientError';
    this.stack = error.stack;
    this.config = error.config;
    this.response = error.response;
    this.status = this.response ? this.response.status : undefined;
    const data = this.response && this.response.data;
    const clientMessage = error.message || '';
    let parsedMessage;
    if (data && data.message) {
      parsedMessage = this.parseMessageApi(data.message);
    } else if (data && data.messages) {
      parsedMessage = this.parseMessagesApi(data.messages);
    }
    this.message = parsedMessage || clientMessage;
    this.code = data && data.messages ? this.parseMessagesCodeApi(data.messages) : undefined;
  }
  toJSON = () => {
    return {
      code: this.code,
      message: this.message,
      status: this.status
    };
  };
  log = () => {
    Sentry.withScope(scope => {
      const {
        config,
        response,
        message,
        status
      } = this;
      const {
        headers,
        params,
        baseURL,
        method,
        url
      } = config;
      const fingerPrints = [];
      scope.addBreadcrumb({
        category: 'xhr',
        data: {
          method: method ? method.toUpperCase() : undefined,
          status_code: status,
          url
        },
        type: 'http'
      });
      baseURL && scope.setTag(LoggerTag.URL, baseURL);
      if (baseURL && url) {
        const path = url.replace(baseURL, '');
        const resource = path.split('/').slice(0, 2).join('/');
        fingerPrints.push(resource);
        scope.setTag(LoggerTag.PATH, path);
        scope.setTag(LoggerTag.RESOURCE, resource);
      }
      if (method) {
        fingerPrints.push(method);
        scope.setTag(LoggerTag.METHOD, method);
      }
      fingerPrints.push(message);
      if (status) {
        fingerPrints.push(status.toString());
        scope.setTag(LoggerTag.STATUS, status.toString());
        scope.setTag(LoggerTag.TYPE, this.getTagErrorType(status));
      }
      scope.setExtra(LoggerContext.REQUEST, {
        headers: Object.keys(headers !== null && headers !== void 0 ? headers : {}),
        params
      });
      response && scope.setExtra(LoggerContext.RESPONSE, {
        data: response.data,
        status: response.status
      });
      fingerPrints.length && scope.setFingerprint(fingerPrints);
      Sentry.captureException(this);
    });
  };
  getTagErrorType = status => {
    if (status === 401) {
      return 'Unauthorized';
    } else if (status >= 400 && status < 500) {
      return 'ClientError';
    } else {
      return 'ServerError';
    }
  };
  parseMessageApi = message => {
    if (Array.isArray(message) && message.length) {
      return message[0];
    } else if (typeof message === 'string') {
      return message;
    }
    return undefined;
  };
  parseMessagesApi = messages => {
    if (Array.isArray(messages) && messages.length) {
      const message = messages[0].message;
      return this.parseMessageApi(message);
    } else if (!Array.isArray(messages)) {
      return this.parseMessageApi(messages.message);
    }
    return undefined;
  };
  parseMessagesCodeApi = messages => {
    if (Array.isArray(messages) && messages.length) {
      return messages[0].code;
    } else if (!Array.isArray(messages)) {
      return messages.code;
    }
    return undefined;
  };
}

export { ApiClientError };
//# sourceMappingURL=ApiClientError.js.map
